import type { DataTableSizeSetting } from '../types';

export default <DataTableSizeSetting[]>[
  {
    label: 'Table Size',
    disabled: true,
    value: null,
  },
  {
    label: 'Compact',
    value: 'compact',
  },
  {
    label: 'Normal',
    value: 'default',
  },
  {
    label: 'Large',
    value: 'large',
  },
];
